import React from "react";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import Signup from "./components/Auth/SignUp";
import Signin from "./components/Auth/SignIn";
import Dashboard from "./components/Dashboard/Dashboard";
import PatientRecord from "./components/PatientRecords/PatientRecord";
import MyPatients from "./components/MyPatients/MyPatients";
import Prescription from "./components/doctor/AddPrescription";

import { BrowserRouter, Route, Switch } from "react-router-dom";
import Landing from "./components/Landing/Landing";

import FormData from "./vithack/form/form";
import Result from "./vithack/result/result";

import "./App.css";

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Landing}>
            {/* <Landing /> */}
          </Route>
          <Route exact path="/dashboard" component={Dashboard}>
            {/* <Dashboard /> */}
          </Route>
          <Route path="/signin" component={Signin}>
            {/* <Dashboard /> */}
            {/* <Chatbot /> */}
          </Route>
          <Route path="/signup" component={Signup}>
            {/* <Signup /> */}
          </Route>
          <Route path="/my-patients" component={MyPatients}>
            {/* <Navbar /> */}
            {/* <MyPatients /> */}
            {/* <Chatbot /> */}
          </Route>
          <Route path="/patient-records" component={PatientRecord}>
            {/* <PatientRecord /> */}
            {/* <Chatbot /> */}
          </Route>
          <Route path="/addprescription" component={Prescription}>
            {/* <Prescription /> */}
            {/* <Chatbot /> */}
          </Route>

          <Route path="/form" component={Prescription}>
            <FormData />
          </Route>

          <Route path="/result" component={Prescription}>
            <Result />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
